import React from "react";

import { Field, Inputs, Row } from "2g-form";

import { useTypyZdroje } from "b2b/api/hooks";
import { useServerMessage } from "b2b/i18n";
import useMessages from "./i18n/useMessages";

export function TypyZdrojuSwitch(props = {}) {
  const { data: typyZdroju } = useTypyZdroje();
  const message = useServerMessage();
  const { typyZdrojuLabel } = useMessages();
  return !typyZdroju ? null : (
    <Row asGroup>
      <Field
        items={typyZdroju}
        label={typyZdrojuLabel()}
        component={Inputs.RadioGroup}
        asSwitch
        path="typZdroje"
        content={({ data }) => message(data.typZdroje, "vyznam")}
        {...props}
      />
    </Row>
  );
}

TypyZdrojuSwitch.propTypes = {};

export default React.memo(TypyZdrojuSwitch);
